export default __webpack_public_path__ + "static/media/logo-nextsong.7b1b8e52.svg";